import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const StrategyIframePage = () => {
    const iframeRef = useRef(null);
    const [iframeLoaded, setIframeLoaded] = useState(false);
    const [iframePath, setIframePath] = useState('/strategy-planning-intro');
    const navigate = useNavigate();
    const location = useLocation();

    const token = localStorage.getItem('npcAuthToken');

    // 🚫 Redirect if not logged in
    useEffect(() => {
        if (!token) {
            const encoded = encodeURIComponent(location.pathname);
            navigate(`/login?redirectTo=${encoded}`);
        }
    }, [token, location.pathname, navigate]);

    // Store embed source in sessionStorage
    useEffect(() => {
        console.log('[🔍 Checking query]', location.search); // should show ?source=npc

        const searchParams = new URLSearchParams(location.search);
        const source = searchParams.get('source');
        if (source) {
            sessionStorage.setItem('iframeSource', source);
            console.log('[📦 Stored iframe source]', source);
        }
    }, [location.search]);

    const source = sessionStorage.getItem('iframeSource') || 'npc';

    const iframeBaseURL =
        window.location.hostname === 'localhost'
            ? 'http://localhost:3000'
            : 'https://www.propsourcing.com.au';

    const iframeSrc = `${iframeBaseURL}${iframePath}?embed=true&source=${source}`;

    // Send auth token to iframe after load
    useEffect(() => {
        if (!token || !iframeLoaded) return;

        iframeRef.current?.contentWindow?.postMessage(
            { type: 'NPC_AUTH_TOKEN', token },
            '*'
        );
        console.log('[🔐 NPC] Sent token to iframe:', token);
    }, [iframeLoaded, token]);

    // Optional: listen for internal iframe navigation requests
    useEffect(() => {
        const handler = (event) => {
            if (event.data?.type === 'NAVIGATE_IFRAME' && event.data?.path) {
                setIframePath(event.data.path);
                setIframeLoaded(false);
            }
        };
        window.addEventListener('message', handler);
        return () => window.removeEventListener('message', handler);
    }, []);

    return (
        <div className="min-h-screen p-6">
            <h1 className="text-2xl font-bold text-center mb-4 text-[#003366]">Strategy Planner</h1>
            <iframe
                ref={iframeRef}
                src={iframeSrc}
                title="Strategy Planner"
                width="100%"
                height="900"
                className="border rounded shadow"
                onLoad={() => setIframeLoaded(true)}
            />
        </div>
    );
};

export default StrategyIframePage;
